export default {
  welcome: 'global.titles.welcome',
  signUp: 'global.account.sign-up',
  email: 'global.account.email',
  password: 'global.account.password'
}
